<template>
  <a-select
    v-bind="selectAttrs"
    allowClear
    showSearch
    optionFilterProp="label"
    :value="internalValue"
    :mode="mode"
    @change="handleChange"
    style="width: 150px"
  >
    <a-select-option
      v-for="option in modifiedOptions"
      :key="option.value"
      :value="option.value"
      :label="option.label"
    >
      {{ option.label }}
    </a-select-option>
  </a-select>
</template>

<script>
import {
  defineComponent,
  inject,
  reactive,
  toRefs,
  computed,
  onMounted,
  watch,
} from 'vue'

export default defineComponent({
  name: 'CustomSelect',
  props: {
    modelValue: {
      type: [String, Number, Object, Boolean, null],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    hasCheckAll: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'combobox',
    },
  },
  setup(props, { emit, attrs }) {
    const $t = inject('$t')

    const state = reactive({
      internalValue: props.modelValue,
      modifiedOptions: computed(() => {
        if (props.hasCheckAll && props.options) {
          return [{ label: $t('checkAll'), value: null }, ...props.options]
        }
        return props.options || []
      }),
    })

    watch(
      () => props.modelValue,
      (val) => {
        state.internalValue = val
      }
    )

    const selectAttrs = computed(() => {
      // eslint-disable-next-line no-unused-vars
      const { onChange, ...restAttrs } = attrs
      return restAttrs
    })

    const handleChange = (val) => {
      state.internalValue = val
      emit('update:modelValue', val)
    }

    onMounted(() => {
      if (state.internalValue === null && state.modifiedOptions.length > 0) {
        state.internalValue = props.hasCheckAll
          ? null
          : state.modifiedOptions[0].value
        emit('update:modelValue', state.internalValue)
      }
    })

    return {
      ...toRefs(state),
      selectAttrs,
      handleChange,
    }
  },
})
</script>
